import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { CommonModule } from '@angular/common';
import { UpdateComponent } from './update.component';
import {
	MatInputModule,
	MatSelectModule,
	MatRadioModule,
	MatButtonModule,
	MatCheckboxModule,
	MatIconModule,
	MatTooltipModule
} from '@angular/material';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [UpdateComponent],
	imports: [
		CommonModule,
		MatInputModule,
		MatSelectModule,
		MatButtonModule,
		MatRadioModule,
		MatCheckboxModule,
		MatIconModule,
		MatTooltipModule,
		FormsModule,
		RouterModule.forChild([{ path: '**', data: SaveStateData, component: UpdateComponent }])
	]
})
export class UpdateModule {}
